<template>
	<div>
		<a-form ref="confFormRef" :model="modelRef" scrollToFirstError name="form" :labelCol="{span: 6, xxl: 5}" :wrapperCol="{span: 16, xxl: 15 }" @finish="onSend">
			<a-spin :spinning="loading">
				<a-form-item label="跳转路径" name="path" :rules="[{required: true, message: '必填项不允许为空'}]">
					<a-input v-model:value="modelRef.path" placeholder="请输入跳转路径"></a-input>
				</a-form-item>
        <div class="ui-warn__box">
          <p>说明:</p>
          <p>配置方式一: pages/dyCoupon/index?accountId={抖音来客accountId}, 与抖音配置的accountId保持一致</p>
          <p>配置方式二: pages/dyCoupon/index?cinemaId={cinemaId}, cinemaId是影院id</p>
          <p style="color: red">注意: 同一个抖音来客, 跳转路径是通用, 改了一个路径其他都会改, 如果多个影院共用一个抖音来客, 请使用accountId方式配置并保持accountId一致!!!</p>
        </div>
			</a-spin>
		</a-form>
	</div>
</template>

<script>
	import { updateMerchantPath } from '@/service/modules/cinema';
	export default {
		props: {
			modelData: {
				type: Object,
				default:() => {}
			},
		},
		data () {
			return {
				loading: false,
				modelRef: {}
			}
		},
		created() {
			this.modelRef = this.$deepClone(this.modelData);
		},
		methods: {
			onSubmit() {
				if (this.loading) return;
				this.$refs.confFormRef.validateFields().then((e) => {
					this.onSend();
				});
			},
			async onSend() {
				let postData = JSON.parse(JSON.stringify(this.modelRef));
				this.loading = true;
				let ret = await updateMerchantPath(postData);
				this.loading = false;
				if (ret.code === 200) {
					this.$message.success('修改成功');
					this.$emit('close');
				}
			}
		}
	}
</script>

<style>
    .ui-warn__box {
        margin: 10px 0 20px 0;
        padding: 10px 20px;
        background-color: antiquewhite;
        border-radius: 10px;
    }
    .ui-warn {
        color: #737272;
    }
</style>
